module.exports = require("docx");